const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/contact",
    exact: true,
    component: "Contact",
  },
];

export default routes;